const getters = {
	// user
	token: state => state.mars.user.token,
	openId: state => state.mars.user.openId,
	userInfo: state => state.mars.user.userInfo,
	loginStatus: state => state.mars.user.loginStatus,
	tempToken: state => state.mars.user.tempToken,
}
export default getters